import api from '@/api/index.js'

const account_journey = {
  state: {
    loading: false,
    updating: false,
    data: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_JOURNEY_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_JOURNEY_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_ACCOUNT_JOURNEY: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_JOURNEY_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadAccountJourney({commit}, req) {
      commit('SET_ACCOUNT_JOURNEY_LOADING', true)
      commit('SET_ACCOUNT_JOURNEY_ERROR', null)
      return api.get(`accounts/${req.accountID}/journeys/${req.journeyID}`)
        .then((response) => {
          commit('SET_ACCOUNT_JOURNEY', response)
          commit('SET_ACCOUNT_JOURNEY_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_JOURNEY_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  },
}

export default account_journey
